<template>
  <bpb-facts-counter
    class="questionnaire-result-answer__quota"
    :number="quota"
    suffix="%"
    :locale="lang"
    ><p>
      {{ correctAnswers }}
      <a-label
        path="questionnaire.answers.correctOf"
        :is-visible="true"
      ></a-label>
      {{ answersTotal
      }}<a-label path="questionnaire.questions" :is-visible="true"></a-label>:
      <a-label
        path="questionnaire.answers.correspondTo"
        :is-visible="true"
      ></a-label>
      {{ quota }}%.
    </p></bpb-facts-counter
  >
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  inject: ['solution', 'formContext'],
  computed: {
    correctAnswers() {
      let correctAnswers = 0;

      for (let field in this.formContext.fields) {
        this.solution[field].forEach(solution => {
          if (this.formContext.fields[field] === solution) correctAnswers++;
        });
      }
      return correctAnswers;
    },
    answersTotal() {
      return Object.keys(this.formContext.fields).length;
    },
    quota() {
      const quota = (100 / this.answersTotal) * this.correctAnswers;
      return Math.floor(quota * 10) / 10; // Return only one decimal
    },
    ...mapGetters({
      lang: 'labels/activeLanguage',
    }),
  },
};
</script>
